import styled from 'styled-components';

export const ContainerModal = styled.div`
  .modal-header {
    background-color: var(--primary-color);
    color: white;
    border-bottom: none;
    
    .modal-title {
      font-weight: var(--font-weight-semibold);
      font-size: var(--font-size-lg);
    }
    
    .btn-close {
      filter: invert(1);
    }
  }

  .modal-body {
    padding: var(--spacing-2xl);
    background-color: var(--bg-light);
    min-height: 400px;
  }

  .modal-footer {
    background-color: var(--bg-light);
    border-top: 1px solid var(--gray-200);
    padding: var(--spacing-lg) var(--spacing-2xl);
  }

  .channel-info {
    background: white;
    border-radius: var(--border-radius-md);
    padding: var(--spacing-lg);
    border: 1px solid var(--gray-200);
    box-shadow: var(--shadow-sm);
  }

  .users-section {
    .table {
      font-size: var(--font-size-sm);
      margin-bottom: 0;
      
      th {
        background-color: var(--gray-100);
        color: var(--primary-color);
        font-weight: var(--font-weight-semibold);
        border-color: var(--gray-200);
        font-size: var(--font-size-xs);
        padding: var(--spacing-md);
      }

      td {
        padding: var(--spacing-md);
        vertical-align: middle;
        border-color: var(--gray-200);
        font-size: var(--font-size-xs);
      }

      tbody tr:hover {
        background-color: var(--gray-50);
      }
    }

    .table-responsive {
      border-radius: var(--border-radius-md);
      overflow: hidden;
      box-shadow: var(--shadow-sm);
    }
  }

  .pagination-section {
    border-top: 1px solid var(--gray-200);
    padding-top: var(--spacing-lg);
    margin-top: var(--spacing-lg);
    background: white;
    border-radius: var(--border-radius-md);
    padding: var(--spacing-lg);
  }

  .pagination-controls {
    gap: var(--spacing-sm);
    
    button {
      font-size: var(--font-size-xs);
      
      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
      }
    }
  }
`;
